import { CheckmarkIcon, EyeOffIcon } from "assets/icons";
import cn from "classnames";
import { If, Media } from "components";
import { Link, useParams } from "react-router-dom";
import { Icon } from "ui";

import { EProductVariantVisibility } from "../../../../constants";
import { ColorsSelectorProps } from "./ColorsSelector.type";

import styles from "./ColorsSelector.module.scss";
const ColorsSelector = ({ variantsList }: ColorsSelectorProps) => {
  const { productVariantId, productId, subChildCategoryId, subPage } =
    useParams();

  return (
    <div className={styles.colorsSelector} data-testid="productInfo--colors">
      {variantsList.map((variant) => {
        const isCurrentVariant = productVariantId === variant.id;

        return (
          <Link
            to={`/products/details/${subChildCategoryId}/${productId}/${variant.id}/${subPage}`}
            key={variant.id}
            className={cn(styles.colorsSelector_item, {
              [styles.colorsSelector_item__active]: isCurrentVariant
            })}
          >
            <If
              condition={
                variant.visibility !== EProductVariantVisibility.Visible
              }
            >
              <div className={styles.colorsSelector_hiddenIndicator}>
                <EyeOffIcon
                  fill={
                    variant.visibility === EProductVariantVisibility.Hidden
                      ? "#FF0033"
                      : "#FF754C"
                  }
                  width={24}
                  height={24}
                />
              </div>
            </If>
            <Media mediaFile={variant.images[0]} className="default-image" />

            <If condition={isCurrentVariant}>
              <div className={styles.colorsSelector_activeIndicator}>
                <Icon as={CheckmarkIcon} boxSize={7} color="#FFF" />
              </div>
            </If>
          </Link>
        );
      })}
    </div>
  );
};

export default ColorsSelector;
